import React from 'react'
import { imageAddress, priceStandardView, translate } from '../../utils/useful'
import TLink from '../TLink'

class DashboardBox extends React.Component {

    state = {
        open: false
    }



    render() {

        let link = '/dashboard/' + this.props.data._id
        return (
            <TLink to={link} className="w-100 service-box h-100 d-flex flex-column">
                <div className="w-100 cover-img-container m-0 p-0 flexcc">
                    <TLink className="m-0 p-0 w-100 h-100 flexcc" to={link}>
                        <img className="cover-img m-0 p-0" src={'/images/dashb.jpg'} alt="" />
                    </TLink>
                </div>


                <div className="mx-3 pt-3  pb-3 service-box-content" style={{ flex: 1 }}>
                    <TLink to={link}>
                        <h3 className="font-bold text-semibig m-0">{this.props.data.name}</h3>
                    </TLink>
                    {/* <TLink to={link}><p className="service-box-desc text-smaller">{this.props.data.type}</p></TLink> */}

                    {this.props.data.description && (
                        <TLink to={link}><p className="mt-1" style={{ fontSize: 13 }}>{this.props.data.description}</p></TLink>
                    )}

                    <p className="mt-1" style={{ fontSize: 13 }}>Number of modules: {this.props.data.modules?.length}</p>



                </div>


            </TLink>
        )
    }
}

export default DashboardBox
